import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Paper, Table, TableBody, TableCell, TableRow, withStyles, IconButton } from '@material-ui/core';
import get from 'lodash/get';
import styles from './table-view.style';
import classnames from 'classnames';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

var TableView =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TableView, _React$Component);

  function TableView() {
    var _this;

    _classCallCheck(this, TableView);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableView).apply(this, arguments));
    _this.state = {
      opened: undefined
    };

    _this.getValue = function (data, item) {
      if (item.formatter) {
        return item.formatter(data, item);
      }

      return get(data, item.name, '');
    };

    _this.toggleOpened = function (name) {
      _this.setState({
        opened: _this.state.opened === name ? undefined : name
      });
    };

    return _this;
  }

  _createClass(TableView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          data = _this$props.data,
          columns = _this$props.columns,
          free = _this$props.free,
          keyWidth = _this$props.keyWidth,
          valueWidth = _this$props.valueWidth,
          slim = _this$props.slim;
      var opened = this.state.opened;

      if (data) {
        return React.createElement(Paper, {
          className: classes.paper
        }, React.createElement(Table, {
          size: 'small',
          style: {
            tableLayout: free ? 'auto' : 'fixed'
          }
        }, columns && React.createElement(TableBody, null, columns.map(function (item, index) {
          if (item.hidden && item.hidden(data)) {
            return null;
          }

          var valueStyle = {};
          var keyStyle = {};

          if (valueWidth) {
            valueStyle.width = valueWidth;
          }

          if (keyWidth) {
            keyStyle.width = keyWidth;
          }

          if (item.style) {
            valueStyle = _objectSpread({}, valueStyle, {}, item.style);
            keyStyle = _objectSpread({}, keyStyle, {}, item.style);
          }

          var isRows = !!item.rows;
          return React.createElement(React.Fragment, {
            key: "table-view-row-".concat(index)
          }, React.createElement(TableRow, {
            className: classnames(classes.tr, _defineProperty({}, classes.trSlim, slim))
          }, React.createElement(TableCell, {
            className: classnames(classes.key, _defineProperty({}, classes.tdSlim, slim)),
            style: keyStyle
          }, item.title), React.createElement(TableCell, {
            className: classnames(classes.value, _defineProperty({}, classes.tdSlim, slim)),
            style: valueStyle
          }, !isRows ? _this2.getValue(data, item) : React.createElement(IconButton, {
            onClick: function onClick() {
              _this2.toggleOpened(item.name);
            },
            size: 'small',
            edge: 'end'
          }, opened === item.name ? React.createElement(ExpandLess, {
            fontSize: slim ? 'small' : 'default',
            className: slim ? classes.expandButtonSlim : ''
          }) : React.createElement(ExpandMore, {
            fontSize: slim ? 'small' : 'default',
            className: slim ? classes.expandButtonSlim : ''
          })))), isRows && opened === item.name && item.rows.map(function (row, rowIndex) {
            return React.createElement(TableRow, {
              key: "table-view-row-".concat(index, "-").concat(rowIndex),
              className: classnames(classes.tr, _defineProperty({}, classes.trSlim, slim))
            }, React.createElement(TableCell, {
              className: classnames(classes.key, classes.rowKey, _defineProperty({}, classes.tdSlim, slim)),
              style: keyStyle
            }, row.title), React.createElement(TableCell, {
              className: classnames(classes.value, classes.rowValue, _defineProperty({}, classes.tdSlim, slim)),
              style: valueStyle
            }, _this2.getValue(data[item.name], row)));
          }));
        }))));
      }

      return null;
    }
  }]);

  return TableView;
}(React.Component);

export default withStyles(styles, {
  name: 'TableView'
})(TableView);